/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_List_Filters_DescInputs */

const en_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The new Event List Filters allow users to filter Events based on various criteria such as text content, speakers, tags, and more.`)
};

const fr_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les nouveaux filtres de la liste d’événements permettent de filtrer les événements selon divers critères tels que le contenu du texte, les intervenants, les tags, et plus encore.`)
};

const de_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit den neuen Event-Listenfiltern können Benutzer Events anhand verschiedener Kriterien wie Textinhalt, Sprecher, Schlagwörter und mehr filtern.`)
};

const it_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I nuovi filtri dell'elenco eventi consentono agli utenti di filtrare gli eventi in base a vari criteri, quali contenuto del testo, relatori, tag e altro ancora.`)
};

const ru_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые фильтры списка событий позволяют пользователям фильтровать события по различным критериям, таким как текстовое содержимое, докладчики, теги и многое другое.`)
};

const es_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los nuevos filtros de lista de eventos permiten a los usuarios filtrar eventos según diversos criterios, como contenido de texto, oradores, etiquetas y más.`)
};

const zh_cn2_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新的活动列表筛选器允许用户根据各种条件（例如文本内容、演讲者、标签等）筛选活动。`)
};

const ja_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベント リスト フィルターを使用すると、ユーザーはテキスト コンテンツ、スピーカー、タグなどのさまざまな基準に基づいてイベントをフィルターできます。`)
};

const hi_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए इवेंट लिस्ट फिल्टर उपयोगकर्ताओं को टेक्स्ट कंटेंट, वक्ताओं, टैग और अन्य जैसे विभिन्न मानदंडों के आधार पर इवेंट्स को फिल्टर करने की अनुमति देते हैं।`)
};

const pt_pt2_event_list_filters_desc = /** @type {(inputs: Event_List_Filters_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os novos filtros da lista de eventos permitem que os usuários filtrem eventos com base em vários critérios, como conteúdo de texto, palestrantes, tags e muito mais.`)
};

/**
* | output |
* | --- |
* | "The new Event List Filters allow users to filter Events based on various criteria such as text content, speakers, tags, and more." |
*
* @param {Event_List_Filters_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_list_filters_desc = /** @type {((inputs?: Event_List_Filters_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_List_Filters_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_list_filters_desc(inputs)
	if (locale === "de") return de_event_list_filters_desc(inputs)
	if (locale === "it") return it_event_list_filters_desc(inputs)
	if (locale === "ru") return ru_event_list_filters_desc(inputs)
	if (locale === "es") return es_event_list_filters_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_event_list_filters_desc(inputs)
	if (locale === "ja") return ja_event_list_filters_desc(inputs)
	if (locale === "hi") return hi_event_list_filters_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_event_list_filters_desc(inputs)
	return en_event_list_filters_desc(inputs)
});